import { createTranslationRef, createTranslationResource } from '@backstage/core-plugin-api/alpha';

export const settingsPageTranslationRef = createTranslationRef({
  id: 'settings-page',
  messages: {
    permissions: {
      title: "Permissions",
      project: {
        title: "Projects"
      },
      application: {
        title: "Applications"
      },
      table: {
        code: "Code",
        name: "Name",
        role: "Role"
      },
      delegations: {
        title: "Delegations",
        addButton: "Add Delegate",
        loading: "Loading...",
        notFound: "No delegations found",
        table: {
          delegate: "Delegate",
          actions: "Actions"
        }
      }
    },
  },
});

export const entityPageTranslations = createTranslationResource({
  ref: settingsPageTranslationRef,
  translations: {
    en: () => import('./settings-page-en'),
    es: () => import('./settings-page-es'),
  },
});